export default __webpack_public_path__ + "static/media/evaluate_Icon.05bf9160.svg";